export default "__VITE_ASSET__eb0d1844__"